import React from "react";
import "./schedule.css";
import Navbar from "../components/Navbar/Navbar";

const Schedule = () => {
  return (
    <div className="page-container">
      <div className="schedule-wrapper">
        <div className="header">
          <span className="page-title">KIST HACKATHON</span>
          <Navbar />
        </div>
        <table id="schedule">
          <thead>
            <tr>
              <th>Day</th>
              <th>Date</th>
              <th>Time</th>
              <th>Event</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td rowSpan="13">Day 2: Opening Ceremony | Hackathon</td>
              <td rowSpan="13">June 7, 2024</td>
              <td>7:00 AM - 7:15 AM</td>
              <td>Opening Ceremony Starts</td>
            </tr>
            <tr>
              <td>7:15 AM - 7:20 AM</td>
              <td>Inauguration Ceremony</td>
            </tr>
            <tr>
              <td>7:20 AM - 7:30 AM</td>
              <td>Opening Speech</td>
            </tr>
            <tr>
              <td>7:35 AM - 7:55 AM</td>
              <td>Event Overview in detail</td>
            </tr>
            <tr>
              <td>7:55 AM - 8:00 AM</td>
              <td>Closing to Opening Ceremony</td>
            </tr>
            <tr>
              <td>8:00 AM - 8:30 AM</td>
              <td>Room Allocation and setup</td>
            </tr>
            <tr>
              <td>8:30 AM</td>
              <td>48 HOURS HACKATHON STARTS</td>
            </tr>
            <tr>
              <td>8:30 AM - 11:00 AM</td>
              <td>Hackathon Idea Brainstorming Time</td>
            </tr>
            <tr>
              <td>9:00 AM - 10:00 AM</td>
              <td>Lunch Break</td>
            </tr>
            <tr>
              <td>11:00 AM onwards</td>
              <td>Hackathon Continues</td>
            </tr>
            <tr>
              <td>1:00 PM - 2:00 PM</td>
              <td>Snacks Break (Mentoring Session)</td>
            </tr>
            <tr>
              <td>7:30 PM - 8:30 PM</td>
              <td>Dinner Break</td>
            </tr>
            <tr>
              <td>1:00 AM - 1:30 AM</td>
              <td>Midnight Snack (Hackathon Continues)</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Schedule;
